import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../common_functions';

const MovableWorkList = props => {
  const [portfolio, setPortfolio] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record?.conceptual_number?.name}</span>,
      ...filter('name'),
    },
    {
      title: 'Portfolio Number',
      dataIndex: 'conceptual_number',
      key: 'conceptual_number',
      // sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record?.conceptual_number?.number}</span>,
      ...filter('conceptual_number'),
    },
    {
      title: 'Artist/Creator',
      dataIndex: 'artist',
      key: 'artist',
      sorter: true,
      render: (text, record) => (
        <span style={{ textTransform: 'capitalize' }}>{!!record.artist && `${record.artist.First_Name} ${record.artist.last_name}`}</span>
      ),
      ...filter('artist'),
    },
    {
      title: 'Edition Set Number',
      dataIndex: 'edition_number',
      key: 'edition_number',
      sorter: true,
      ...filter('edition_number'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/portfolio-movable-work/edit/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.portfolio_movable_work?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.portfolio_movable_work?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'portfolio',
              'Portfolio movable work?',
              portfolio,
              setPortfolio,
              props?.tabs_permissions?.portfolio_movable_work?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getPortfolioData(pagination);
  })();
  }, []);

  const getPortfolioData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      filters['type'] = { _eq: process.env.movable_work_id };
      const response = await props.getItems('portfolio', {
        fields: ['*', 'artist.First_Name', 'artist.last_name', 'edition_number', 'conceptual_number.number', 'conceptual_number.name'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setPortfolio(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key == 'artist') {
            filtersitems['_or'] = [{ artist: { last_name: { _icontains: val[0] } } }, { artist: { First_Name: { _icontains: val[0] } } }];
          } else if (key == 'conceptual_number' || key === 'name') {
            // filtersitems[key] = { number: { _icontains: val[0] } };
            filtersitems['_or'] = [
              { conceptual_number: { number: { _icontains: val[0] } } },
              { conceptual_number: { name: { _icontains: val[0] } } },
            ];
          } else if (key == 'conceptual_number' && key === 'name') {
            // filtersitems[key] = { number: { _icontains: val[0] } };
            filtersitems['_and'] = [
              { conceptual_number: { number: { _icontains: val[0] } } },
              { conceptual_number: { name: { _icontains: val[0] } } },
            ];
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }
    await getPortfolioData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Portfolio Movable Work" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Portfolio Movable Work
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.portfolio_movable_work,
                `/portfolio-movable-work/new`,
                'Create Portfolio Movable Work'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={portfolio}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default MovableWorkList;
